import React from 'react';
import { useParams } from 'react-router-dom';
import DbtTestsTable from '../../components/dbt/DbtTestsTable';
import { FeatureGate } from '../../components/billing';

/**
 * DbtTestsPage
 * Page displaying all tests for a project
 */
const DbtTestsPage = () => {
  const { projectId } = useParams();

  return (
    <FeatureGate
      feature="dbt_enabled"
      upgradeMessage="View and monitor your dbt test results."
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">dbt Tests</h1>
          <p className="text-base-content/70 mt-2">
            View and monitor your dbt test results
          </p>
        </div>

        {projectId ? (
          <DbtTestsTable projectId={projectId} />
        ) : (
          <div className="alert alert-warning">
            <span>Project ID is required.</span>
          </div>
        )}
      </div>
    </FeatureGate>
  );
};

export default DbtTestsPage;
